import { lazy } from "react";
import type { RouteObject } from "react-router";

const StockLedger = lazy(() => import("./pages/stock-ledger/page"));
const Warehouses = lazy(() => import("./pages/warehouses/page"));
const PeriodClose = lazy(() => import("./pages/period-close/page"));

// Delivery Orders
const DeliveryOrders = lazy(() => import("./pages/delivery-orders/page"));
const DeliveryOrderNew = lazy(() => import("./pages/delivery-orders/new/page"));
const DeliveryOrderDetail = lazy(() => import("./pages/delivery-orders/[id]/page"));

// Stock Transfers
const StockTransfers = lazy(() => import("./pages/stock-transfers/page"));
const StockTransferNew = lazy(() => import("./pages/stock-transfers/new/page"));
const StockTransferDetail = lazy(() => import("./pages/stock-transfers/[id]/page"));

// Goods Receipts
const GoodsReceipts = lazy(() => import("./pages/goods-receipts/page"));
const GoodsReceiptNew = lazy(() => import("./pages/goods-receipts/new/page"));
const GoodsReceiptDetail = lazy(() => import("./pages/goods-receipts/[id]/page"));

export const inventoryRoutes: RouteObject[] = [
  { path: "stock-ledger", Component: StockLedger },
  { path: "period-close", Component: PeriodClose },
  { path: "warehouses", Component: Warehouses },

  // Delivery Orders
  { path: "delivery-orders", Component: DeliveryOrders },
  { path: "delivery-orders/new", Component: DeliveryOrderNew },
  { path: "delivery-orders/:id", Component: DeliveryOrderDetail },

  // Stock Transfers
  { path: "stock-transfers", Component: StockTransfers },
  { path: "stock-transfers/new", Component: StockTransferNew },
  { path: "stock-transfers/:id", Component: StockTransferDetail },

  // Goods Receipts
  { path: "goods-receipts", Component: GoodsReceipts },
  { path: "goods-receipts/new", Component: GoodsReceiptNew },
  { path: "goods-receipts/:id", Component: GoodsReceiptDetail },
];
